import { useState } from 'react'
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaPhone, FaMapMarkerAlt, FaClock, FaArrowRight } from 'react-icons/fa'

const Footer = ({ restaurant }) => {
  const currentYear = new Date().getFullYear()
  const name = restaurant?.name || 'Bread & Sandwich'
  const description = restaurant?.description || "Fresh ingredients, handcrafted recipes, and unforgettable taste."
  const phone = restaurant?.contact?.phone || ''
  const address = restaurant?.contact?.address ? `${restaurant.contact.address}${restaurant.contact.city ? ', ' + restaurant.contact.city : ''}` : ''
  const social = restaurant?.socialMedia || {}
  const initials = name.split(' ').map(w => w[0]).join('').slice(0, 3).toUpperCase()

  return (
    <>
      <footer id="footer" className="footer-container">
        {/* Browser Version - 4 Columns */}
        <div className="footer-desktop">
          <div className="footer-background"></div>
          
          <div className="footer-content">
            <div className="footer-grid">
              {/* Column 1: Brand & Description */}
              <div className="footer-column">
                <div className="footer-logo">
                  <div className="footer-logo-icon">{initials}</div>
                  <h2 className="footer-brand">{name}</h2>
                </div>
                <p className="footer-description">{description}</p>
                
                <div className="footer-social">
                  {[
                    { icon: <FaFacebookF />, label: 'Facebook', key: 'facebook' },
                    { icon: <FaInstagram />, label: 'Instagram', key: 'instagram' },
                    { icon: <FaTwitter />, label: 'Twitter', key: 'twitter' },
                    { icon: <FaYoutube />, label: 'YouTube', key: 'youtube' }
                  ].map((s, index) => (
                    <a
                      key={index}
                      href={social[s.key] || '#'}
                      target={social[s.key] ? '_blank' : undefined}
                      rel="noopener noreferrer"
                      aria-label={s.label}
                      className="footer-social-link"
                    >
                      {s.icon}
                    </a>
                  ))}
                </div>
              </div>

              {/* Column 2: Quick Links */}
              <div className="footer-column">
                <h3 className="footer-heading">Liens</h3>
                <ul className="footer-links">
                  {['Accueil', 'Menu', 'À propos', 'Contact'].map((item) => (
                    <li key={item}>
                      <a
                        href={`#${item.toLowerCase().replace(' ', '-')}`}
                        className="footer-link"
                      >
                        <FaArrowRight size={12} className="footer-link-icon" />
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Column 3: Contact Info */}
              <div className="footer-column">
                <h3 className="footer-heading">Coordonnées</h3>
                <div className="footer-contact">
                  <div className="footer-contact-item">
                    <div className="footer-contact-icon">
                      <FaMapMarkerAlt />
                    </div>
                    <div>
                      <p className="footer-contact-title">Nous trouver</p>
                      <p className="footer-contact-detail">
                        {address || '—'}
                      </p>
                    </div>
                  </div>

                  <div className="footer-contact-item">
                    <div className="footer-contact-icon">
                      <FaPhone />
                    </div>
                    <div>
                      <p className="footer-contact-title">Contactez-nous</p>
                      <p className="footer-contact-detail">
                        {phone || '—'}
                      </p>
                    </div>
                  </div>

                  <div className="footer-contact-item">
                    <div className="footer-contact-icon">
                      <FaClock />
                    </div>
                    <div>
                      <p className="footer-contact-title">Horaires</p>
                      <p className="footer-contact-detail">
                        Lun-Dim: 11h - 22h<br />
                        Cuisine ferme à 22:30
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Column 4: Location Map */}
              <div className="footer-column">
                <h3 className="footer-heading">Nous trouver</h3>
                <div className="footer-map">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.349173579673!2d-7.589632884793698!3d33.59319878073222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7cd4778aa113b%3A0xb06c1d84f310fd3!2sCasablanca%2C%20Morocco!5e0!3m2!1sen!2s!4v1641234567890!5m2!1sen!2s"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title={`${name} Location`}
                  ></iframe>
                  <div className="footer-map-overlay"></div>
                </div>
              </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
              <div className="footer-copyright">
                <p>© {currentYear} {name}. All rights reserved.</p>
              </div>
              <div className="footer-legal">
                <a href="#" className="footer-legal-link">Privacy Policy</a>
                <a href="#" className="footer-legal-link">Terms of Service</a>
                <a href="#" className="footer-legal-link">Cookie Policy</a>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Version - Single Column */}
        <div className="footer-mobile">
          <div className="mobile-footer-content">
            {/* Logo & Brand */}
            <div className="mobile-logo-section">
              <div className="mobile-logo">
                <div className="mobile-logo-icon">{initials}</div>
                <h2 className="mobile-brand">{name}</h2>
              </div>
              <p className="mobile-description">{description}</p>
              
              <div className="mobile-social">
                {[
                  { icon: <FaFacebookF />, key: 'facebook' },
                  { icon: <FaInstagram />, key: 'instagram' },
                  { icon: <FaTwitter />, key: 'twitter' },
                  { icon: <FaYoutube />, key: 'youtube' }
                ].map((s, index) => (
                  <a
                    key={index}
                    href={social[s.key] || '#'}
                    target={social[s.key] ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    className="mobile-social-link"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links - Mobile */}
            <div className="mobile-section">
              <h3 className="mobile-heading">LIENS RAPIDES</h3>
              <div className="mobile-links-grid">
                {['Accueil', 'Menu', 'À propos', 'Contact'].map((item) => (
                  <a
                    key={item}
                    href={`#${item.toLowerCase().replace(' ', '-')}`}
                    className="mobile-link"
                  >
                    {item}
                  </a>
                ))}
              </div>
            </div>

            {/* Contact Info - Mobile */}
            <div className="mobile-section">
              <h3 className="mobile-heading">COORDONNÉES</h3>
              <div className="mobile-contact-card">
                <div className="mobile-contact-item">
                  <FaMapMarkerAlt className="mobile-contact-icon" />
                  <div>
                    <p className="mobile-contact-title">Address</p>
                    <p className="mobile-contact-detail">
                      {address || '—'}
                    </p>
                  </div>
                </div>
                <div className="mobile-contact-item">
                  <FaPhone className="mobile-contact-icon" />
                  <div>
                    <p className="mobile-contact-title">Phone</p>
                    <p className="mobile-contact-detail">
                      {phone || '—'}
                    </p>
                  </div>
                </div>
                <div className="mobile-contact-item">
                  <FaClock className="mobile-contact-icon" />
                  <div>
                    <p className="mobile-contact-title">Hours</p>
                    <p className="mobile-contact-detail">
                        Lun-Dim: 11h - 22h
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map - Mobile */}
            <div className="mobile-section">
              <h3 className="mobile-heading">Notre localisation</h3>
              <div className="mobile-map">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3323.349173579673!2d-7.589632884793698!3d33.59319878073222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7cd4778aa113b%3A0xb06c1d84f310fd3!2sCasablanca%2C%20Morocco!5e0!3m2!1sen!2s!4v1641234567890!5m2!1sen!2s"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title={`${name} Location`}
                ></iframe>
              </div>
            </div>

            {/* Bottom Bar - Mobile */}
            <div className="mobile-bottom">
              <p className="mobile-copyright">
                © {currentYear} {name}. Tous droits réservés.
              </p>
              <div className="mobile-legal">
                <a href="#" className="mobile-legal-link">Privacy</a>
                <a href="#" className="mobile-legal-link">Terms</a>
                <a href="#" className="mobile-legal-link">Cookies</a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* CSS Styles */}
      <style jsx>{`
        .footer-container {
          position: relative;
        }

        /* Desktop Footer Styles */
.footer-desktop {
  display: block;
  background-color: #000;
}

        .footer-mobile {
          display: none;
        }

        .footer-background {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(255,107,0,0.03) 0%, transparent 100%);
          z-index: 1;
        }

        .footer-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 80px 40px 40px 40px;
          position: relative;
          z-index: 2;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 50px;
          margin-bottom: 60px;
        }

        .footer-logo {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 25px;
        }

        .footer-logo-icon {
          width: 50px;
          height: 50px;
          background-color: #ff6b00;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 24px;
          box-shadow: 0 0 20px rgba(255, 107, 0, 0.3);
        }

        .footer-brand {
          font-size: 28px;
          font-weight: bold;
          margin: 0;
          color: white;
        }

        .footer-brand-accent {
          color: #ff6b00;
        }

        .footer-description {
          color: rgba(255,255,255,0.7);
          margin-bottom: 30px;
          font-size: 15px;
          line-height: 1.7;
        }

        .footer-social {
          display: flex;
          gap: 15px;
        }

        .footer-social-link {
          width: 45px;
          height: 45px;
          background-color: rgba(255,255,255,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: all 0.3s;
          border: 1px solid rgba(255,255,255,0.1);
        }

        .footer-social-link:hover {
          transform: translateY(-3px);
        }

        .footer-social-link:nth-child(1):hover { background-color: #1877F2; border-color: #1877F2; }
        .footer-social-link:nth-child(2):hover { background-color: #E4405F; border-color: #E4405F; }
        .footer-social-link:nth-child(3):hover { background-color: #1DA1F2; border-color: #1DA1F2; }
        .footer-social-link:nth-child(4):hover { background-color: #FF0000; border-color: #FF0000; }

        .footer-heading {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 30px;
          color: white;
          position: relative;
          padding-bottom: 15px;
        }

        .footer-heading:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 50px;
          height: 3px;
          background-color: #ff6b00;
          border-radius: 2px;
        }

        .footer-links {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .footer-link {
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          font-size: 15px;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .footer-link:hover {
          color: #ff6b00;
          padding-left: 10px;
        }

        .footer-link-icon {
          opacity: 0.5;
        }

        .footer-contact {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .footer-contact-item {
          display: flex;
          align-items: flex-start;
          gap: 15px;
        }

        .footer-contact-icon {
          width: 40px;
          height: 40px;
          background-color: rgba(255,107,0,0.1);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ff6b00;
          flex-shrink: 0;
        }

        .footer-contact-title {
          color: white;
          margin: 0 0 5px 0;
          font-weight: 500;
          font-size: 15px;
        }

        .footer-contact-detail {
          color: rgba(255,255,255,0.7);
          margin: 0;
          font-size: 14px;
          line-height: 1.5;
        }

        .footer-map {
          background-color: rgba(255,255,255,0.05);
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.1);
          margin-bottom: 20px;
          height: 200px;
          position: relative;
        }

        .footer-map-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
          background: linear-gradient(135deg, rgba(255,107,0,0.1) 0%, transparent 50%);
        }

        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding-top: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 20px;
        }

        .footer-copyright {
          color: rgba(255,255,255,0.5);
          margin: 0;
          font-size: 14px;
        }

        .footer-legal {
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
        }

        .footer-legal-link {
          color: rgba(255,255,255,0.6);
          text-decoration: none;
          font-size: 14px;
          transition: color 0.3s;
        }

        .footer-legal-link:hover {
          color: #ff6b00;
        }

        /* Mobile Footer Styles */
        .mobile-footer-content {
          padding: 40px 20px 30px 20px;
          background-color: #000;
          color: white;
        }

        .mobile-logo-section {
          text-align: center;
          margin-bottom: 30px;
        }

        .mobile-logo {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 15px;
        }

        .mobile-logo-icon {
          width: 45px;
          height: 45px;
          background-color: #ff6b00;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 22px;
          box-shadow: 0 0 15px rgba(255, 107, 0, 0.3);
        }

        .mobile-brand {
          font-size: 24px;
          font-weight: bold;
          margin: 0;
          color: white;
        }

        .mobile-brand-accent {
          color: #ff6b00;
        }

        .mobile-description {
          color: rgba(255,255,255,0.7);
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 20px;
        }

        .mobile-social {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin-bottom: 30px;
        }

        .mobile-social-link {
          width: 40px;
          height: 40px;
          background-color: rgba(255,255,255,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          text-decoration: none;
        }

        .mobile-section {
          margin-bottom: 30px;
        }

        .mobile-heading {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
          color: white;
          text-align: center;
          border-bottom: 2px solid #ff6b00;
          padding-bottom: 8px;
        }

        .mobile-links-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .mobile-link {
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          font-size: 14px;
          padding: 12px;
          background-color: rgba(255,255,255,0.05);
          border-radius: 8px;
          text-align: center;
          border: 1px solid rgba(255,255,255,0.1);
        }

        .mobile-contact-card {
          background-color: rgba(255,255,255,0.05);
          padding: 20px;
          border-radius: 12px;
          border: 1px solid rgba(255,255,255,0.1);
        }

        .mobile-contact-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 15px;
        }

        .mobile-contact-item:last-child {
          margin-bottom: 0;
        }

        .mobile-contact-icon {
          color: #ff6b00;
          font-size: 18px;
          flex-shrink: 0;
        }

        .mobile-contact-title {
          color: #ff6b00;
          margin: 0 0 4px 0;
          font-size: 13px;
          font-weight: 500;
        }

        .mobile-contact-detail {
          color: rgba(255,255,255,0.8);
          margin: 0;
          font-size: 13px;
        }

        .mobile-map {
          background-color: rgba(255,255,255,0.05);
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.1);
          height: 180px;
        }

        .mobile-bottom {
          border-top: 1px solid rgba(255,255,255,0.1);
          padding-top: 20px;
          text-align: center;
        }

        .mobile-copyright {
          color: rgba(255,255,255,0.5);
          margin: 0 0 15px 0;
          font-size: 13px;
        }

        .mobile-legal {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .mobile-legal-link {
          color: rgba(255,255,255,0.6);
          text-decoration: none;
          font-size: 12px;
        }

        /* Media Queries */
        @media (max-width: 768px) {
          .footer-desktop {
            display: none !important;
          }
          .footer-mobile {
            display: block !important;
          }
        }

        @media (min-width: 769px) {
          .footer-desktop {
            display: block !important;
          }
          .footer-mobile {
            display: none !important;
          }
        }
      `}</style>
    </>
  )
}

export default Footer